export { default as HomeComponent } from './Home/Home';
export { default as LoginComponent } from './Login/Login';
export { default as MarketComponent } from './Market/Market';
export { default as CollectionDetail} from './Market/CollectionDetail';
export { default as ExploreContent} from './Market/ExploreContent';
export { default as AboutComponent } from './About/About';
export { default as ActivityComponent } from './Activity/Activity';
export { default as ProfileComponent } from './UserProfile/UserProfile';
